import img1mob from '../../assets/images/img1mx2.jpg';
import img1web from '../../assets/images/img1wx2.jpg';
import img2mob from '../../assets/images/img2wx1.jpg';
import img2web from '../../assets/images/img2wx2.jpg';
import img3mob from '../../assets/images/img3mx2.jpg';
import img3web from '../../assets/images/img3wx2.jpg';
import img4mob from '../../assets/images/img4wx1.jpg';
import img4web from '../../assets/images/img4wx2.jpg';
import img5mob from '../../assets/images/img5wx1.jpg';
import img5web from '../../assets/images/img5wx2.jpg';


const CasesArr = [
    {
        id: 1,
        imagemob: `${img1mob}`,
        imageweb: `${img1web}`,
        title: 'Lviv Region, Radekhiv town Private Enterprise “ZAKHIDNYI BUH”',
        description: 'Wind Power for auto field irrigation',
        date: 'July 2023'
    },
    {
        id: 2,
        imagemob: `${img2mob}`,
        imageweb: `${img2web}`,
        title: 'Zhytomyr city Private Enterprise “Bosch”',
        description: 'Solar Panels for industrial use',
        date: 'November 2023'
    },
    {
        id: 3,
        imagemob: `${img3mob}`,
        imageweb: `${img3web}`,
        title: 'Rivne city Private Enterprise “Biotech”',
        description: 'Thermal modules',
        date: 'October 2023'
    },
    {
        id: 4,
        imagemob: `${img4mob}`,
        imageweb: `${img4web}`,
        title: 'Kherson city Private Enterprise “HealthyFarm”.',
        description: 'Wind power',
        date: 'September 2021'
    },
    {
        id: 5,
        imagemob: `${img5mob}`,
        imageweb: `${img5web}`,
        title: 'Zaporizhia city Private Enterprise “Biotech”',
        description: 'Mini nuclear stations',
        date: 'May 2021'
    },
];

export default CasesArr;